import { swoopAPI } from '@/api'

export const getNotificationById = id => swoopAPI.get(`/api/v1/notifications/${id}`)
export const getNotifications = companyId => swoopAPI.get(`/api/v1/notifications/company/${companyId}`)
export const getNewestNotifications = companyId => swoopAPI.get(`/api/v1/notifications/company/${companyId}/newest`)
export const getAnyUnreadNotification = companyId => swoopAPI.get(`/api/v1/notifications/company/${companyId}/anyUnread`)
export const updateNotificationStatus = id => swoopAPI.patch(`/api/v1/notifications/updateStatus/${id}`)
